<template>
  <div>
    <div class="row px-2">
      <b-input-group>
        <b-input-group-prepend>
          <b-form-select
            v-model="innerValue.bs"
            :options="options"
            size="sm"
            class="myInputSelect"
            @change="applyFilters(); setFilter({key: field, value: innerValue}); showSecondInputs()" />
        </b-input-group-prepend>
        <b-form-input
          type="date"
          size="sm"
          v-model="innerValue.from"
          class="myInput"
          @change="applyFilters(); setFilter({key: field, value: innerValue});" />
      </b-input-group>
    </div>

    <div class="row px-2"
         v-show="showOptions2">
      <b-input-group>
        <b-input-group-prepend>
          <b-form-select
            v-model="innerValue.as"
            :options="options2"
            size="sm"
            class="myInputSelect"
            @change="applyFilters(); setFilter({key: field, value: innerValue});" />
        </b-input-group-prepend>
        <b-form-input
          type="date"
          size="sm"
          v-model="innerValue.to"
          class="myInput"
          @change="applyFilters(); setFilter({key: field, value: innerValue});" />
      </b-input-group>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  name: 'DateFilter',
  props: {
    value: {
      type: Object,
      required: true,
      validator(val) {
        const requiredFields = ['bs', 'from', 'as', 'to'];
        return Object.keys(val).every((x) => requiredFields.indexOf(x) > -1) && Object.keys(val).length === requiredFields.length;
      }
    },
    field: {
      type: String,
      required: true
    }
  },
  methods: {
    applyFilters() {
      if (this.$moment(this.innerValue.from).isValid()) {
        if (this.innerValue.bs === '==') {
          this.$emit('filter', () => (x) => this.$moment(x[this.field], 'DD.MM.YYYY').isSame(this.innerValue.from, 'day'));
        } else if (this.innerValue.to.length === 0) {
          switch (this.innerValue.bs) {
            case '<=':
              this.$emit('filter', () => (x) => this.$moment(x[this.field], 'DD.MM.YYYY').isSameOrBefore(this.innerValue.from, 'day'));
              break;
            case '>=':
              this.$emit('filter', () => (x) => this.$moment(x[this.field], 'DD.MM.YYYY').isSameOrAfter(this.innerValue.from, 'day'));
              break;
            default:
              break;
          }
        } else if (this.$moment(this.innerValue.to).isValid()) {
          if (this.$moment(this.innerValue.to).isAfter(this.innerValue.from, 'day')) {
            this.$emit('filter', () => (x) => this.$moment(x[this.field], 'DD.MM.YYYY').isBetween(this.innerValue.from, this.innerValue.to, 'day', '[]'));
          } else {
            this.$emit('filter', () => (x) => this.$moment(x[this.field], 'DD.MM.YYYY').isBetween(this.innerValue.to, this.innerValue.from, 'day', '[]'));
          }
        }
      } else {
        this.$emit('filter', () => () => true);
      }
    },
    showSecondInputs() {
      this.showOptions2 = this.innerValue.bs !== '==';

      if (this.innerValue.bs === '>=') {
        this.options2 = this.options.filter((x) => x.value !== '>=' && x.value !== '==');
      }
      if (this.innerValue.bs === '<=') {
        this.options2 = this.options.filter((x) => x.value !== '<=' && x.value !== '==');
      }
    },
    ...mapMutations({
      setFilter: 'dataTableFilters/setFilter'
    })
  },
  computed: {
    innerValue: {
      get() {
        return this.$store.state.dataTableFilters.filters[this.field] || this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
      deep: true
    }
  },
  data() {
    return {
      options: [
        { value: '>=', text: '>=' },
        { value: '<=', text: '<=' },
        { value: '==', text: '=' }
      ],
      options2: [],
      showOptions2: false
    };
  },
  mounted() {
    this.applyFilters();
  }
};
</script>
<style>

</style>
